import WorkoutBreakdown from './workout-breakdown';

export default WorkoutBreakdown;
